import { m } from 'framer-motion';
import { alpha, Box, Button, Container, Stack, styled, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { MotionViewport, TextAnimate, varFade } from '../../components/animate';
import { PATH_PAGE } from '../../routes/paths';

const ContentStyle = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundImage: 'url(/assets/background/img_5837.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const CardViewStyle = styled('div')(({ url }) => ({
  width: '100%',
  height: '100%',
  backgroundImage: `url(/assets/clearoverlay.svg), url(/assets/background/${url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export default function HomeGuideInvestisseur() {
  return (
    <ContentStyle>
      <Stack width={1} height={1} bgcolor={alpha('#000', 0.8)} my={1}>
        <Container width={1}>
          <Stack component={MotionViewport} width={{ xs: 1, md: 0.5 }} py={{ xs: 2, md: 20 }}>
            <TextAnimate variants={varFade().inRight} addspace text="Le Guide de l'Investisseur" sx={{ width: {xs:1, md:450}}} color="common.white" />
       
            <Box height={15} width={150} bgcolor="warning.main" mb={3} />
            <m.div variants={varFade().inRight}>
              <Typography variant="h5" fontWeight={200} pr={{ md: 5 }} color="common.white" textAlign="justify">
                Le climat des affaires au Togo devient de plus en plus favorable aux investisseurs grâce aux progrès
                réalisés notamment sur le plan des réformes. Outre l'évolution de l'attractivité du pays, on note des
                efforts consacrés à la digitalisation des procédures administratives.
              </Typography>
            </m.div>
          </Stack>

          <Stack display={{ md: 'none' }} spacing={2} pb={3}>
            <InvestCard
              url="AdobeStock_191995730.jpg"
              title="Explorez les opportunités et les procédures"
              title2="d'investissement au Togo"
              action="Acceder au portail"          
              color="error"
              link="https://investirautogo.tg/"
              isExt
            />
            <InvestCard
              url="AdobeStock_176545019.jpg"
              title="Guichet Unique de l'Investissement (GUI)"
              action="Découvrir"
              color="warning"
              link={PATH_PAGE.guichet_unique.guichet_unique_de_l_investissement}
            />
          </Stack>
        </Container>

        <Stack
          position={{ xs: 'absolute' }}
          display={{ xs: 'none', md: 'block' }}
          top={-15}
          bottom={-15}
          left={0}
          right={0}
        >
          <Stack height={1} width={1} alignItems="end">
            <Stack
              component={MotionViewport}
              height="100vmin"
              width={{ xs: 1, md: 0.5 }}
              bgcolor="#fff"
              pr={5}
              spacing={1}
            >
              <m.div variants={varFade().inRight} whileHover={{ scale: 1.1 }}>
                <InvestCard
                  url="AdobeStock_191995730.jpg"
                  title="Explorer les opportunités et les procédures d'investissement au Togo"
                  action="Acceder au portail"
                  color="error"
                  link="https://investirautogo.tg/"
                  isExt
                  variant
                />
              </m.div>
              <m.div variants={varFade().inRight} whileHover={{ scale: 1.1 }}>
                <InvestCard
                  url="AdobeStock_176545019.jpg"
                  title="Guichet Unique de"
                  title2="l'Investissement (GUI)"
                  action="Découvrir"
                  color="warning"
                  variant
                  link={PATH_PAGE.guichet_unique.guichet_unique_de_l_investissement}
                />
              </m.div>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </ContentStyle>
  );
}

const InvestCard = ({ url, title, title2, action, link, isExt = false, color, sx, variant=false}) => {
  const [hover, setHover] = useState(false);

  return (
    <CardViewStyle
      url={url}
      sx={{ px: 5, py: 10, cursor: 'pointer' }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Stack alignItems="end">
        <Typography
          textAlign="end"
          color="common.white"
          {...(variant && { variant: 'h3' })}
          sx={{ fontSize: variant ? 32 : 25, fontWeight: 'bold', ...sx }}
        >
          {title}
        </Typography>
        {title2 && (
          <Typography textAlign="end" color="common.white" sx={{ fontSize: variant ? 28 : 20, fontWeight: 'bold' }}>
            {title2}
          </Typography>
        )}
        <Button
          {...(!isExt && { component: RouterLink, to: link })}
          {...(isExt && { href: link, target: '_blank', rel: 'noopener' })}
          variant="contained"
          color={color}
          sx={{
            px: 3,
            fontSize: 25,
            borderRadius: 3,

            color: 'common.white',
            opacity: hover ? 1 : 0,
            transition: 'opacity 0.5s ease-in-out',
          }}
        >
          {action}
        </Button>
      </Stack>
    </CardViewStyle>
  );
};
